/* istanbul ignore file */
import { computed } from 'vue';
import { useAvailability } from '@nuxt-common/media-card-large/app/composables/useAvailability';
import { useType } from '~/modules/type/composables/useType';
import useSize from '~/modules/size/composables/useSize';
import { useProductFlags } from '~/modules/featureControl/composables/useProductFlags';
import useUpc from '~/modules/upc/composables/useUpc';
import { useProduct } from '~/modules/product/composables/useProduct';
import { isAnyUpcAvailable } from '../utils/utils';

function sizeDrivenMapper(availability, sizeProps) {
  return {
    ...sizeProps,
    sizes: sizeProps.sizes?.map((size) => ({ ...size, available: isAnyUpcAvailable(availability, { sizeId: size.id }) })) || [],
  };
}

export default function useSizeVariant() {
  const { isTypeDrivenThirdVariantFlag: isTypeDriven } = useProductFlags();
  const { productId, productData: product } = useProduct();
  const { sizeProps } = useSize();
  const { size: sizeAvailability } = useAvailability(productId);
  const { traitsMap } = useUpc();
  const isSizeDriven = !isTypeDriven;
  const { selectedTypeId } = useType();

  const filteredSizeProps = computed(() => {
    if (isSizeDriven) {
      return sizeDrivenMapper(traitsMap.value, sizeProps.value);
    }

    const type = product.traits.types.typeMap[selectedTypeId.value] || {};
    const sizeIdsForType = Object.keys(type.sizeToColors).map((id) => parseInt(id, 10)) || [];

    return {
      ...sizeProps,
      sizes: sizeProps.value.sizes
        ?.filter((size) => sizeIdsForType.includes(size.id))
        .map((size) => ({
          id: size.id,
          available: sizeAvailability.value[size.id],
          displayName: size.displayName,
          name: size.name,
        })),
    };
  });

  const availableSizes = computed(() => filteredSizeProps.value.sizes.filter((size) => sizeAvailability.value[size.id]));

  return {
    filteredSizeProps,
    availableSizes,
  };
}
